import counterStatesActionTypes from "../actions/counterStatesActionTypes";
import { reducerFactory } from "../../common/redux/reducers/reducerFactory";

export const counterStatesReducer = reducerFactory.readReducer(
  counterStatesActionTypes
);
